import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { KeycloakUserConnectService } from '@wheere-front/shared-auth';
import { provideIcons } from '@ng-icons/core';
import { ngIcons } from '@wheere-front/inside-shared-data-access';
import { CustomerShellComponent } from '@wheere-front/customer-shared-ui';
import { WhToastComponent } from '@wheere-front/shared-ui';
import { PrimeNG } from 'primeng/config';
import { NetworkPollingService } from '@wheere-front/shared-util';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CustomerShellComponent, WhToastComponent],
  template: `
    <lib-customer-shell>
      <router-outlet />
    </lib-customer-shell>
    <!-- Le toast unique de l'app : tout MessageService.add(...) s'affiche ici, quelle que soit sa key. -->
    <wh-toast />
  `,
  providers: [provideIcons(ngIcons)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  #keycloakUserConnectService = inject(KeycloakUserConnectService);

  constructor(
    private primeNg: PrimeNG,
    private networkPolling: NetworkPollingService
  ) {
    this.#keycloakUserConnectService.init();
    this.primeNg.ripple.set(true);
  }
}
